
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TreeEntryCommit"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LogTreeCommit"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sha"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"titleHtml"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"committedDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"commitPath"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fileName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"filePath"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":132}};
    doc.loc.source = {"body":"fragment TreeEntryCommit on LogTreeCommit {\n  sha\n  message\n  titleHtml\n  committedDate\n  commitPath\n  fileName\n  filePath\n  type\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
